import React from 'react';
import job from '../Image/job.webp';
import network_icon from '../Image/network_icon.webp';
import communities_club from '../Image/communities_club.webp';
import social_media from '../Image/social_media.webp';
const data = [
  {
    img: job,
    alt: 'Connect your friends to the most fascinating internships & jobs',
    text: 'Connect your friends to the most fascinating internships & jobs'
  },
  {
    img: network_icon,
    alt: 'Be the face of Internselite at your Campus and enhance your networking skills',
    text: 'Be the face of Internselite at your Campus and enhance your networking skills'
  },
  {
    img: communities_club,
    alt: 'Assist us in reaching out to your College’s Communities & Clubs',
    text: 'Assist us in reaching out to your College’s Communities & Clubs'
  },
  {
    img: social_media,
    alt: 'Influence your peers on social media and promote community learning',
    text: 'Influence your peers on social media and promote community learning'
  }
];

function CA_second_comp() {
  return (
    <>
      {/* -----------------Mobile View------------------- */}
      <div className='CA_second_background d-sm-block d-md-none'>
        <div className='container CA_second_main_box py-3 pb-4'>
          <div className='pt-4'>
            <h2 className='text-center mobile_CA_second_comp_txt'>What will you be doing?</h2>
          </div>
          <div className='row'>
            {data.map((item, index) => (
              <div className='col-md-12 py-4 px-5' key={index}>
                <div className='row border bg-white p-3 CA_second_comp_border shadow'>
                  <div className='col-12 text-center pt-2'>
                    <img className='border-bottom pb-1 CA_Program_card_Img' src={item.img} alt={item.alt} onContextMenu={(e) => e.preventDefault()}></img>
                  </div>
                  <div className='col-12'>
                    <p className='text-center pt-2 CA_second_comp_txt'>{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* -----------------Desktop View------------------- */}
      <div className='CA_second_background d-none d-md-block'>
        <div className='container CA_second_main_box py-3'>
          <div className='pb-4'>
            <h2 className='text-center CA_second_comp_txt display-6'>What will you be doing?</h2>
          </div>
          <div className='row p-3'>
            {data.map((item, index) => (
              <div className='col-md-6 px-4 my-2' key={index}>
                <div className='row border bg-white CA_second_comp_border shadow'>
                  <div className='col-4'>
                    <img className='CA_Program_card_Img p-1' src={item.img} alt={item.alt} onContextMenu={(e) => e.preventDefault()}></img>
                  </div>
                  <div className='col-8 pt-4'>
                    <p>{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default CA_second_comp;
